import "./index.scss";
import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { LINK_LIST } from "./utils/constants";

export const OrderFaq = () => (
  <div className="order-faq">
    <h4>eGift Cards &amp; Vouchers</h4>
    <p>
      Most electronic gift cards are delivered instantly to your GCX account,
      but please allow up to 24 hours. You will receive email notification upon
      delivery.
    </p>
    <h4>90 Day Money-Back Guarantee</h4>
    <p>
      Our{" "}
      <NavLink
        to={INTERNAL_PATHS.GUARANTEE}
        target="_blank"
        aria-label="90 Day Money-Back Guarantee"
        rel="noopener noreferrer"
      >
        90 Day Money-Back Guarantee
      </NavLink>{" "}
      covers all gift cards that cannot be redeemed as indicated for 90 days
      from the date of purchase.
    </p>
    <h4>Need Help?</h4>
    <ul className="links">
      {LINK_LIST.map(({ path, label }) => (
        <li key={label}>
          <NavLink
            to={path}
            aria-label={label}
            target="_blank"
            rel="noopener noreferrer"
          >
            {label}
          </NavLink>
        </li>
      ))}
    </ul>
  </div>
);
